import { useParams, useHistory, } from 'react-router-dom';
import { MenuItem, Select } from "@material-ui/core";

const SlotList = ({ events }) => {

  const history = useHistory();
  let nbrOfFree = 0;
  let { storeId, eventId, slotId } = useParams();

  const handleEventChange = (e) => {
    history.push("/butiker/" + storeId + "/boka-tid/" + eventId + "/tid/" + e.target.value);
  };
  return (
    <>
      <Select
        labelId="select-event"
        id="select-event"
        value={slotId}
        onChange={handleEventChange}
        label="Select-time"
        variant='filled'
      >
        {
          events[eventId]?.slots?.map((slot) => {
            if (slot.id === slotId) {
              nbrOfFree = slot.max - slot.count;
              nbrOfFree = nbrOfFree < 0 ? 0 : nbrOfFree;
            }
            return (
              <MenuItem
                key={slot.time}
                value={slot.time}
                style={{ paddingTop: "15px" }}
              >
                {slot.time}
              </MenuItem>
            );
          })
        }
      </Select>
    </>
  )
}
export default SlotList;